import { MemoruHomeResourceDownloadResponse } from "@API/src/component/memoruHome/resource/types";

export const isTypeMemoruHomeResourceDownloadResponse = (arg): arg is MemoruHomeResourceDownloadResponse =>
  arg !== null &&
  typeof arg === "object" &&
  typeof (arg as MemoruHomeResourceDownloadResponse).preSignedUrl === "string" &&
  typeof (arg as MemoruHomeResourceDownloadResponse).preSignedDownloadUrl === "string";
